import React from 'react'
import SbEditable from 'storyblok-react'
import TextRenderer from '../TextRenderer'
import Image from './../Image'

import styles from './styles.module.scss'

const Usps = (props) => {
	return (
		<SbEditable content={props.blok}>
			<section className={styles['usps']} style={{ backgroundColor: props.blok.background_color }}>
                {props.blok.vertical_title && <span className={'section-title'}>{props.blok.title}</span>}
                <div className='container'>
                    <ul className={styles['usps__list']}>
                        {props.blok.usp_items.map((item, i) => {
                            return (
                                <SbEditable key={i} content={item}>
                                    <li className={styles['usp-item']}>
                                        <img className={styles['usp-item__icon']} src={item.icon.filename} alt={item.icon.alt} />
                                        <TextRenderer className={styles['usp-item__description']} text={item.description} />
                                    </li>
                                </SbEditable>
                            )
                        })}
                    </ul>
                </div>
            </section>
		</SbEditable>
	)
}

export default Usps